import { configureStore } from "@reduxjs/toolkit";
import contactReducer from '../BiencapsSlice/ContactSlice';


export const store = configureStore({
    reducer: {
        userInfo: contactReducer,
    }
})
